import React from 'react'
import { Typography, Paper, Box, LinearProgress } from '@mui/material'
import _sortBy from 'lodash/sortBy'

const StatsShirtDistribution = ({ shirts }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: { xs: 1.5, sm: 2, md: 2.5 },
        mb: { xs: 2, sm: 2.5, md: 3 },
      }}>
      {shirts &&
        _sortBy(shirts, 'shirtType').map((shirt) => {
          const shirtColor = shirt.shirtType === 'Short Sleeves' ? '#FF9800' : '#4CAF50'
          return (
            <Paper
              key={shirt.shirtType}
              elevation={0}
              sx={(theme) => {
                const gapXs = theme.spacing(1.5)
                const gapSm = theme.spacing(2)
                const gapMd = theme.spacing(2.5)
                return {
                  p: { xs: 1.5, sm: 2.5, md: 3 },
                  borderRadius: 2,
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? 'rgba(255, 255, 255, 1)'
                      : 'rgba(18, 18, 18, 1)',
                  border: (theme) =>
                    `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
                  boxShadow: (theme) =>
                    theme.palette.mode === 'light'
                      ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                      : '0 2px 8px rgba(0, 0, 0, 0.3)',
                  flex: {
                    xs: '0 0 100%',
                    sm: `0 0 calc((100% - ${gapSm}) / 2)`,
                    md: `0 0 calc((100% - ${gapMd}) / 2)`,
                  },
                  width: {
                    xs: '100%',
                    sm: `calc((100% - ${gapSm}) / 2)`,
                    md: `calc((100% - ${gapMd}) / 2)`,
                  },
                }
              }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: { xs: 1.5, sm: 2.5, md: 3 },
                }}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: shirtColor,
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
                  }}>
                  Shirt Type: {shirt.shirtType}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: { xs: 1, sm: 1.25, md: 1.5 },
                }}>
                {shirt.sizes.map((size) => {
                  const progress = size.total > 0 ? (size.distributed / size.total) * 100 : 0
                  return (
                    <Box
                      key={size.size}
                      sx={(theme) => {
                        const gapXs = theme.spacing(1)
                        const gapSm = theme.spacing(1.25)
                        const gapMd = theme.spacing(1.5)
                        return {
                          flex: {
                            xs: `0 0 calc((100% - ${gapXs}) / 2)`,
                            sm: `0 0 calc((100% - ${gapSm} * 2) / 3)`,
                            md: `0 0 calc((100% - ${gapMd} * 3) / 4)`,
                          },
                          width: {
                            xs: `calc((100% - ${gapXs}) / 2)`,
                            sm: `calc((100% - ${gapSm} * 2) / 3)`,
                            md: `calc((100% - ${gapMd} * 3) / 4)`,
                          },
                        }
                      }}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: { xs: 1, sm: 1.25, md: 1.5 },
                          borderRadius: 1.25,
                          backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                              ? 'rgba(249, 250, 251, 0.5)'
                              : 'rgba(18, 18, 18, 0.5)',
                          border: (theme) =>
                            `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
                        }}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: 'text.secondary',
                            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
                            mb: { xs: 0.5, sm: 0.5, md: 0.75 },
                          }}>
                          {size.size}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: 'text.primary',
                            fontSize: { xs: '0.9375rem', sm: '1rem', md: '1.0625rem' },
                            mb: { xs: 0.75, sm: 0.75, md: 1 },
                          }}>
                          {size.distributed?.toLocaleString() || '0'} /{' '}
                          {size.total?.toLocaleString() || '0'}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={progress}
                          sx={{
                            height: { xs: 4, sm: 5, md: 6 },
                            borderRadius: 1,
                            backgroundColor: (theme) =>
                              theme.palette.mode === 'light'
                                ? 'rgba(0, 0, 0, 0.08)'
                                : 'rgba(255, 255, 255, 0.12)',
                            '& .MuiLinearProgress-bar': {
                              borderRadius: 1,
                              backgroundColor: shirtColor,
                            },
                          }}
                        />
                      </Paper>
                    </Box>
                  )
                })}
              </Box>
            </Paper>
          )
        })}
    </Box>
  )
}

export default StatsShirtDistribution
